import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5c1adfac")
const _hoisted_1 = { id: "side-tool-bar-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "select-overlay" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Text", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "tool-icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(1.01809,0,0,1.01809,-1550.82,-1578.03)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M1542.85,1556.27L1538.22,1550.1C1538.17,1550.03 1538.09,1549.99 1538,1549.99C1537.91,1549.99 1537.83,1550.03 1537.78,1550.1L1533.15,1556.27C1533.02,1556.46 1532.99,1556.99 1533.22,1556.99L1536.69,1556.99L1536.69,1565.62C1536.69,1566.2 1537.41,1566.48 1538,1566.48C1538.59,1566.48 1539.31,1566.2 1539.31,1565.62L1539.31,1556.99L1542.78,1556.99C1543.01,1556.99 1542.98,1556.46 1542.85,1556.27ZM1547.13,1558.72L1541.48,1558.72C1541,1558.71 1540.61,1559.1 1540.61,1559.57C1540.61,1560.05 1541,1560.44 1541.48,1560.44L1546.26,1560.44L1546.26,1571.22L1540.61,1571.22C1540.13,1571.22 1539.74,1571.61 1539.74,1572.08L1539.74,1577.69L1529.74,1577.69L1529.74,1560.44L1534.52,1560.44C1535,1560.44 1535.39,1560.05 1535.39,1559.57C1535.39,1559.1 1535,1558.71 1534.52,1558.72L1528.87,1558.72C1528.39,1558.71 1528,1559.1 1528,1559.57L1528,1578.55C1528,1579.02 1528.39,1579.41 1528.87,1579.41C1528.87,1579.41 1528.87,1579.41 1528.87,1579.41L1540.61,1579.41L1548,1572.08L1548,1559.57C1548,1559.1 1547.6,1558.71 1547.13,1558.72Z" })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Upload Art", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "tool-icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 30 30",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(1.24347,0,0,1.24347,-0.813102,-0.418805)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M17.714,7.252C16.911,3.242 13.357,0.33 9.268,0.33C4.542,0.33 0.654,4.219 0.654,8.944C0.654,13.023 3.551,16.571 7.548,17.385L7.548,23.568C7.549,24.039 7.937,24.427 8.408,24.427C8.408,24.427 8.409,24.427 8.409,24.427L23.919,24.427C23.919,24.427 23.92,24.427 23.92,24.427C24.391,24.427 24.779,24.039 24.78,23.568L24.78,8.111C24.779,7.64 24.391,7.252 23.92,7.252C23.92,7.252 23.919,7.252 23.919,7.252L17.714,7.252ZM2.406,8.347C2.739,4.826 5.731,2.103 9.268,2.103C12.393,2.103 15.146,4.229 15.937,7.252L8.409,7.252C8.409,7.252 8.408,7.252 8.408,7.252C7.937,7.252 7.549,7.64 7.548,8.111L7.548,15.611C4.3,14.779 2.111,11.687 2.406,8.347Z" })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Shapes", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "tool-icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(0.99001,0,0,0.99001,-0.660337,2.69382)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M32.667,27.233L2,27.233C1.304,27.15 0.75,26.596 0.667,25.9L0.667,1.986C0.752,1.292 1.305,0.741 2,0.658L32.667,0.658C33.362,0.741 33.914,1.292 34,1.986L34,25.9C33.916,26.596 33.363,27.149 32.667,27.233ZM31.334,3.315L3.334,3.315L3.334,24.575L31.334,24.575L31.334,3.315ZM14.654,9.066C14.758,8.917 14.929,8.827 15.111,8.827C15.293,8.827 15.464,8.917 15.568,9.066L20.406,16.03C20.51,16.179 20.68,16.268 20.862,16.268C21.036,16.268 21.201,16.186 21.306,16.047L22.444,14.536C22.549,14.396 22.713,14.314 22.888,14.314C23.063,14.314 23.227,14.396 23.332,14.536L28.888,21.918C29.162,22.283 29.123,23.247 28.666,23.247L6,23.247C5.552,23.247 5.46,22.302 5.714,21.935L14.654,9.066ZM26.222,11.731C24.404,11.724 22.912,10.227 22.912,8.409C22.912,6.587 24.412,5.087 26.234,5.087C28.056,5.087 29.556,6.587 29.556,8.409C29.553,10.232 28.051,11.731 26.228,11.731C26.226,11.731 26.224,11.731 26.222,11.731Z" })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Background", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "tool-icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  version: "1.1",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.229,14l-7.78,0l0,-7.78c0,-1.708 -1.405,-3.113 -3.112,-3.113l-6.225,0c-1.707,0 -3.112,1.405 -3.112,3.113l0,12.448c0,1.708 1.405,3.112 3.112,3.112l1.556,0l0,1.557c0,1.707 1.405,3.112 3.112,3.112l12.449,0c1.707,0 3.112,-1.405 3.112,-3.112l0,-6.225c0,-1.707 -1.405,-3.112 -3.112,-3.112Zm-17.117,6.224c-0.853,-0.001 -1.555,-0.702 -1.556,-1.556l0,-12.448c0.001,-0.854 0.703,-1.556 1.556,-1.556l6.225,0c0.853,0 1.555,0.702 1.556,1.556l0,7.78l-3.113,0c-1.707,0 -3.112,1.405 -3.112,3.112l0,3.112l-1.556,0Zm7.781,-4.668l0,3.112c-0.001,0.854 -0.703,1.555 -1.556,1.556l-3.113,0l0,-3.112c0.001,-0.853 0.703,-1.555 1.556,-1.556l3.113,0Zm10.892,7.781c-0.001,0.853 -0.703,1.555 -1.556,1.556l-12.449,0c-0.853,-0.001 -1.555,-0.703 -1.556,-1.556l0,-1.557l3.113,0c1.707,0 3.112,-1.404 3.112,-3.112l0,-3.112l7.78,0c0.853,0.001 1.555,0.703 1.556,1.556l0,6.225Zm5.997,-14.233l-3.113,3.112c-0.301,0.301 -0.796,0.302 -1.098,0.002l-3.226,-3.203c-0.147,-0.146 -0.23,-0.345 -0.23,-0.552c0,-0.428 0.351,-0.779 0.778,-0.779c0.206,0 0.403,0.081 0.549,0.226l1.864,1.852c-0.175,-3.703 -3.27,-6.655 -6.977,-6.655c-0.478,0 -0.956,0.049 -1.424,0.147c-0.052,0.011 -0.106,0.017 -0.16,0.017c-0.426,0 -0.777,-0.351 -0.777,-0.778c0,-0.367 0.26,-0.687 0.62,-0.762c0.574,-0.119 1.159,-0.18 1.745,-0.18c4.579,0 8.387,3.676 8.549,8.252l1.799,-1.799c0.145,-0.14 0.339,-0.219 0.541,-0.219c0.427,0 0.778,0.351 0.778,0.778c0,0.202 -0.078,0.396 -0.218,0.541l0,0Z",
    style: {"fill-rule":"nonzero"}
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Rotate", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "tool-icon",
  width: "22",
  height: "26",
  viewBox: "0 0 22 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 26h20a.91.91 0 001-1V1a.91.91 0 00-1-1H1a.92.92 0 00-1 1v24a.92.92 0 001 1zm19-10h-8v-6h8v6zm-10 0H2v-6h8v6zm-8 2h8v6H2v-6zm15 4v2h-5v-6h8v4h-3zm3-14h-8V2h8v6zM2 2h8v6H2V2z",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Layout", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Settings", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "tool-label" }, "Help", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Accordian = _resolveComponent("Accordian")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "side-tool",
        id: "text",
        ref: "onBoardingTextRef",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setAccordianState('Text')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "tool-icon",
          icon: "font",
          "aria-hidden": "true"
        }),
        _hoisted_3
      ], 512),
      _createElementVNode("div", {
        class: "side-tool",
        id: "image",
        ref: "onBoardingImageRef",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAccordianState('Image')))
      }, _hoisted_6, 512),
      _createElementVNode("div", {
        class: "side-tool",
        id: "shapes",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAccordianState('Shapes')))
      }, _hoisted_9),
      _createElementVNode("div", {
        class: "side-tool",
        id: "clipart",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAccordianState('ClipArt')))
      }, [
        _hoisted_10,
        _createElementVNode("div", {
          class: "tool-label",
          style: _normalizeStyle(_ctx.tool === 'ClipArt' ? 'color: rgb(7, 205, 234);' : '')
        }, "Clipart", 4)
      ]),
      (_ctx.isMobile || _ctx.clientDimensions.width <= 767)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "side-tool",
            id: "background",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAccordianState('Background')))
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "tool-icon",
              icon: "fill-drip",
              "aria-hidden": "true"
            }),
            _hoisted_11
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMobile || _ctx.clientDimensions.width <= 767)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "side-tool",
            id: "rotate",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setAccordianState('Rotate')))
          }, _hoisted_14))
        : _createCommentVNode("", true),
      (_ctx.isPrintedSheetLabel)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "side-tool",
            id: "layout",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setAccordianState('Layout')))
          }, _hoisted_17))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref: "onBoardingSettingsRef",
        class: "side-tool",
        id: "settings",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setAccordianState('Settings')))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: "tool-icon",
          icon: "cog",
          "aria-hidden": "true"
        }),
        _hoisted_18
      ], 512),
      (!_ctx.isMobile && _ctx.clientDimensions.width > 767)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openHelp && _ctx.openHelp(...args))),
            class: "side-tool",
            id: "help",
            ref: "helpRef"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "tool-icon",
              icon: "question-circle",
              "aria-hidden": "true"
            }),
            _hoisted_19
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Accordian)
  ]))
}